import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { useRef, useState } from 'react';
import editFill from '@iconify/icons-eva/edit-fill';
import { LinkasRouterLink, useNavigate } from 'react-router-dom';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import copyOutline from '@iconify/icons-eva/copy-outline';
import { toast } from 'react-hot-toast';
// material
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import isEligible from '../../../utils/roleEligibleGetter';

// ----------------------------------------------------------------------

TokenMoreMenu.propTypes = {
  onDelete: PropTypes.func.isRequired,
  rowData: PropTypes.object.isRequired
};
export default function TokenMoreMenu({ onDelete, rowData }) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const theme = useTheme();

  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          onClick={() => {
            navigator.clipboard.writeText(rowData.id);
            toast.success('ID telah di-copy');
            setIsOpen(false);
          }}
          sx={{ color: 'text.secondary' }}
        >
          <ListItemIcon>
            <Icon icon={copyOutline} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Copy" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
        {isEligible('delete_token') && (
          <MenuItem
            sx={{
              color: rowData?.status?.toLowerCase() === 'free' ? 'red' : theme.palette.grey[400]
            }}
            onClick={() =>
              rowData?.status?.toLowerCase() === 'free'
                ? onDelete(rowData)
                : toast.error('Token sudah digunakan')
            }
          >
            <ListItemIcon>
              <Icon icon={trash2Outline} width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="Delete" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
